export default __webpack_public_path__ + "static/media/gallery-wip-bunny-ears_07.05cb4b66.jpg";